import { FormInput } from 'components/molecules';
import { useTranslation } from 'react-i18next';
import { PiUserCircleDashed } from 'react-icons/pi';
import { useGetArtistLightList } from 'services/artists/light';
import { IUpdateArtistDuplicate } from 'services/artists/types';
import PopupForm, { IPopupFormProps } from '../form/PopupForm';

interface IArtistDuplicatePopupProps
  extends Omit<IPopupFormProps<IUpdateArtistDuplicate>, 'header'> {
  duplicateName?: string;
  originalName?: string;
}

const ArtistDuplicatePopup = ({
  originalName,
  duplicateName,
  ...props
}: IArtistDuplicatePopupProps) => {
  const { t } = useTranslation();
  const artists = useGetArtistLightList();
  const artistsOptions =
    artists.data?.map(a => ({ label: a.nickname, value: a.id })) ?? [];
  return (
    <PopupForm<IUpdateArtistDuplicate>
      header={
        <>
          <PiUserCircleDashed /> {t('artist.duplicate-popup.header')}
        </>
      }
      {...props}>
      {({ values }) => (
        <div className='flex flex-col w-full gap-8 max-w-[350px]'>
          <p className='text-[13px] p-[20px] pt-0 opacity-65'>
            {t('artist.duplicate-popup.description')}
          </p>
          <FormInput.Select
            label={t('input.label.original')}
            name='originalArtistId'
            options={artistsOptions}
            value={
              originalName
                ? { value: values.originalArtistId, label: originalName }
                : undefined
            }
            displayMode={!!originalName}
            isLoading={artists.isLoading}
          />
          <FormInput.Select
            label={t('input.label.duplicate')}
            name='artistId'
            value={
              duplicateName
                ? { value: values.artistId, label: duplicateName }
                : undefined
            }
            displayMode={!!duplicateName}
            options={artistsOptions.filter(
              option => option.value !== values.originalArtistId
            )}
            isLoading={artists.isLoading}
          />
        </div>
      )}
    </PopupForm>
  );
};

export default ArtistDuplicatePopup;
